import { IBranding } from '../models/branding.model';

export const exampleBranding: IBranding = {
    "agent1_name": "Ryan Taylor", 
    "agent1_designation": "Realtor\u00ae", 
    "agent1_phone": "905-831-2222", 
    "agent2_name": "Trevor Snooks", 
    "agent2_designation": "Realtor\u00ae", 
    "agent2_phone": "905-831-2223", 
    "brokerage_name": "Royal Heritage Realty Ltd, Brokerage", 
    "brokerage_logo_url": "https://taylorsnooks.ca/wp-content/uploads/2023/01/royal-heritage-realty-ltd-brokerage-logo.png", 
    "primary_colour": "#355070", 
    "secondary_colour": "#5B9279", 
    "search_map_height_offset": "0px",
    "walkscore_api_key": "g54abe503c6354ffa8d61881565699f7b"
};
